export default __webpack_public_path__ + "static/media/info.6c30e314.svg";